import { format, isValid, parseISO } from 'date-fns';

const toDate = (value) => {
  if (!value) return null;

  if (value instanceof Date) {
    return isValid(value) ? value : null;
  }

  if (typeof value === 'number') {
    const numericDate = new Date(value);
    return isValid(numericDate) ? numericDate : null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return null;

    const parsedIso = parseISO(trimmed);
    if (isValid(parsedIso)) return parsedIso;

    const fallbackParsed = new Date(trimmed);
    return isValid(fallbackParsed) ? fallbackParsed : null;
  }

  return null;
};

export const formatDateInputISO = (value, fallback = '') => {
  const dateValue = toDate(value);
  if (!dateValue) return fallback;
  return format(dateValue, 'yyyy-MM-dd');
};

export const formatDateDDMMYYYY = (value, fallback = '—') => {
  const dateValue = toDate(value);
  if (!dateValue) return fallback;
  return format(dateValue, 'dd-MM-yyyy');
};

export const formatDateWord = (value, fallback = '—') => {
  const dateValue = toDate(value);
  if (!dateValue) return fallback;
  return format(dateValue, 'MMM d yyyy');
};

export const formatDateTimeDDMMYYYY = (value, fallback = '—') => {
  const dateValue = toDate(value);
  if (!dateValue) return fallback;
  return format(dateValue, 'dd-MM-yyyy h:mm a');
};

export const formatDateTimeWord = (value, fallback = '—') => {
  const dateValue = toDate(value);
  if (!dateValue) return fallback;
  return format(dateValue, 'MMM d yyyy h:mm a');
};
